import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from '../../../Axiosinstance';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
const NewStudent = () => {
  const [categories, setCategories] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedBatch, setSelectedBatch] = useState('');
  const [language, setLanguage] = useState('');
  const [languages, setLanguages] = useState([]);
  const [location, setLocation] = useState('');
  const navigate = useNavigate();
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [categoriesResponse, venuesResponse] = await Promise.all([
          axios.get('/categories/findall'),
          axios.get('/wsq/venues/finalls')
        ]);
        setCategories(categoriesResponse.data);
        setVenues(venuesResponse.data);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to load categories or venues. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;
    setSelectedCategory(categoryId);
    setSelectedCourse('');
    setBatches([]);
    setSelectedBatch('');
    
    try {
      const response = await axios.get(`/wsq/courses/by-category?categoryId=${categoryId.id}`);
      setCourses(response.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  const handleCourseChange = async (event) => {
    const selectedCourseId = event.target.value;
    setSelectedCourse(selectedCourseId);
    setSelectedBatch('');
    setLanguage('');

    // Find the selected course and set its languages
    const selectedCourseData = courses.find((course) => course.id === selectedCourseId);
    setLanguages(selectedCourseData ? selectedCourseData.languages : []);
    
    // Fetch batch data using the selected course, language, and location
    try {
      const response = await axios.get(`/wsq/batches/search?courseName=${selectedCourseData.name}&categoryName=${selectedCategory.name}&language=${language}&place=${location}`);
      setBatches(response.data); // Set the fetched batch data
    } catch (error) {
      console.error('Error fetching batches:', error);
    }
  };

  const handleBatchChange = (e) => {
    setSelectedBatch(e.target.value);
  };

  const handleNextClick = () => {
    const selectedBatchData = batches.find((batch) => batch.id === selectedBatch);
  
    if (!selectedBatchData) {
      toast.error('Please select a batch.', {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
  
    if (selectedBatchData.language !== language) {
      toast.error(
        `The selected language "${language}" is not available for the chosen batch. The available language for this batch is "${selectedBatchData.language}". Please select the correct language.`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
      return;
    }
  
    navigate(`/Studentcompany/${selectedBatch}`);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Student Registration
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Please fill out the form to register for a course.
        </Typography>
      </Box>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>Select Category</InputLabel>
        <Select label="Select Category" value={selectedCategory} onChange={handleCategoryChange}>
          {categories.map((category) => (
            <MenuItem key={category.id} value={category}>
              {category.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }} disabled={!selectedCategory}>
        <InputLabel>Select Course</InputLabel>
        <Select label="Select Course" value={selectedCourse} onChange={handleCourseChange}>
          {courses.map((course) => (
            <MenuItem key={course.id} value={course.id}>
              {course.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }} disabled={!selectedCourse}>
        <InputLabel>Select Language</InputLabel>
        <Select label="Select Language" value={language} onChange={handleLanguageChange}>
          {languages.map((lang) => (
            <MenuItem key={lang} value={lang}>
              {lang}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>Select Location</InputLabel>
        <Select label="Select Location" value={location} onChange={handleLocationChange}>
          {venues.map((venue) => (
            <MenuItem key={venue.id} value={venue.place || ''}>
              {venue.place || 'Unknown Location'}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }} disabled={!selectedCourse}>
        <InputLabel>Select Batch</InputLabel>
        <Select label="Select Batch" value={selectedBatch} onChange={handleBatchChange}>
          {batches.map((batch) => (
            <MenuItem key={batch.id} value={batch.id}>
              {batch.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Button variant="contained" color="primary" onClick={handleNextClick} disabled={!selectedBatch}>
          Next
        </Button>
      </Box>
      <ToastContainer />
    </Container>
  );
};

export default NewStudent;
